
export default {
  props: {
    label: {
      type: String,
      default: 'Fortsæt'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
